import { Client } from '../types/client';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3003/api';

export const clientApiService = {
  /**
   * Fetch all clients from the backend
   */
  fetchClients: async (): Promise<Client[]> => {
    try {
      const response = await fetch(`${API_BASE_URL}/clients`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.error || 'Failed to fetch clients');
      }

      return data.clients;
    } catch (error) {
      console.error('Error fetching clients from API:', error);
      throw error;
    }
  },

  /**
   * Create a new client
   */
  createClient: async (client: Client): Promise<Client> => {
    try {
      const response = await fetch(`${API_BASE_URL}/clients`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(client)
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.error || 'Failed to create client');
      }

      return data.client;
    } catch (error) {
      console.error('Error creating client:', error);
      throw error;
    }
  },

  /**
   * Update an existing client
   */
  updateClient: async (client: Client): Promise<Client> => {
    try {
      const response = await fetch(`${API_BASE_URL}/clients/${client.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(client)
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.error || 'Failed to update client');
      }

      return data.client;
    } catch (error) {
      console.error('Error updating client:', error);
      throw error;
    }
  },

  /**
   * Delete a client by ID
   */
  deleteClient: async (id: string): Promise<void> => {
    try {
      const response = await fetch(`${API_BASE_URL}/clients/${id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.error || 'Failed to delete client');
      }
    } catch (error) {
      console.error('Error deleting client:', error);
      throw error;
    }
  },

  /**
   * Delete all clients (for testing/admin)
   */
  deleteAllClients: async (): Promise<void> => {
    try {
      const response = await fetch(`${API_BASE_URL}/clients`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.error || 'Failed to delete all clients');
      }
    } catch (error) {
      console.error('Error deleting all clients:', error);
      throw error;
    }
  }
};
